export default "__VITE_ASSET__BqaK060g__"